import { ratingTypes } from 'shared/constants/ratingTypes';

const productAvailable = productItem => productItem && !productItem.purchased;
const sigProductAvailable = productItem => productItem && !productItem.requested;

export const ratingRequestAvailable = (product, ratingType) => {
  switch (ratingType) {
    case ratingTypes.CREDIT_REVIEW:
      return sigProductAvailable(product);
    case ratingTypes.CREDIT_RATING:
    default:
      return product && (productAvailable(product.l4) || productAvailable(product.l5));
  }
};
